import { JSX, useState } from "react";

import { ExternalUser } from "models/customers/customers";
import ExternalUsersEdit from "./ExternalUsersEdit";
import ExternalUsersSummary from "./ExternalUserSummary";

type Props = {
  users: ExternalUser[];
  collapsed: boolean;
  onItemAdded: (user: Partial<ExternalUser>, isNew?: boolean) => void;
  onItemRemove: (email: string) => void;
  resetValidUserData?: () => void;
  info?: string | JSX.Element;
};

export default function ExternalUsers({
  users,
  collapsed,
  onItemAdded,
  onItemRemove,
  resetValidUserData,
  info
}: Props) {
  const [visible, setVisible] = useState(collapsed ? "summary" : "edit");

  const handleSaveClick = () => {
    setVisible("summary");
  };

  const visibleModule =
    visible === "summary" ? (
      <ExternalUsersSummary users={users} />
    ) : (
      <ExternalUsersEdit
        showSaveButton={collapsed}
        onSaveClick={handleSaveClick}
        externalUsers={users}
        onItemAdded={onItemAdded}
        onItemRemove={onItemRemove}
        resetValidUserData={resetValidUserData}
        info={info}
      />
    );


    return (
        <div>
          {visibleModule}
        </div>
      ); 
}
